import { InputHTMLAttributes } from 'react';
import { InputWrapper } from './styled';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name?: string;
}

export function Input({ children, ...props }: InputProps): JSX.Element {
  return <InputWrapper {...props}>{children}</InputWrapper>;
}
